import css from '@emotion/css';
import React from 'react';
import { Link } from 'react-router-dom';
import { token } from '@atlaskit/tokens';

import { colors } from '@/styles';

// eslint-disable-next-line react/display-name
const LinkWithRef = React.forwardRef<HTMLElement, React.AllHTMLAttributes<HTMLElement>>(
  ({ href = '', children, className }, ref: React.Ref<HTMLAnchorElement>) => (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <Link
      to={href}
      ref={ref}
      css={css`
        color: ${token('color.text.subtlest', colors.N300)};
      `}
      className={`${className || ''} LinkWithRef`}
    >
      {children}
    </Link>
  )
);

export default LinkWithRef;
